import { makeStyles } from "@material-ui/core/styles";
import { StyleVariables } from "./StyleVariable";

/**
 * Material UI framework styling object
 * @type {StylesHook<Styles<Theme, {}, string>>}
 */
const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(0),
    maxWidth: "100%",
    height: "100vh",
  },
  rootNew: {
    height: "100vh",
    display: "flex",
    justifyContent: "space-evenly",
    alignItems: "center",
    padding: theme.spacing(0),
    background: "#1d2136",
    maxWidth: "100%",
  },
  paperNew: {
    marginTop: theme.spacing(0),
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    height: "75%",
    maxHeight: "500px",
    width: "50%",
    borderRadius: "14px",
  },

  paperNewM: {
    marginTop: theme.spacing(0),
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    height: "auto",
    width: "85%",
    borderRadius: "12px",
  },
  paper: {
    marginTop: theme.spacing(0),
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    height: StyleVariables.fullHeight,
  },
  form: {
    width: StyleVariables.fullWidth, // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  linkItem: {
    color: StyleVariables.mutedColor,
    textDecoration: "none",
    "&:hover": {
      textDecoration: "underline",
    },
  },
  spaceTop: {
    marginTop: theme.spacing(1),
  },
  spaceTop2: {
    marginTop: theme.spacing(2),
  },
  spaceTop3: {
    marginTop: theme.spacing(3),
  },
  spaceBottom: {
    marginBottom: theme.spacing(1),
  },
  spaceBottom2: {
    marginBottom: theme.spacing(2),
  },
  loginFont: {
    fontFamily: "inherit",
  },

  loginBackButton: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },

  brandLogo: {
    maxWidth: "200px",
    alignItems: "center",
    justifyContent: "center",
    width: StyleVariables.fullWidth,
    display: "flex",
    color: StyleVariables.whiteColor,
  },

  brandTag: {
    alignItems: "center",
    justifyContent: "center",
    width: StyleVariables.fullWidth,
    color: StyleVariables.whiteColor,
    // "& h6": {
    //   fontWeight: "300",
    // },
  },
  panelWidth: {
    width: "50%",
    [theme.breakpoints.down("md")]: {
      width: "100%",
    },
  },
  forgotButton: {
    marginBottom: "4%",
  },
  authInnerForm: {
    textAlign: StyleVariables.alignCenter,
    margin: StyleVariables.alignAuto,
    width: "100%",
    [theme.breakpoints.up("sm")]: {
      width: "100%",
    },
    [theme.breakpoints.up("lg")]: {
      width: "90%",
    },
    [theme.breakpoints.up("xl")]: {
      width: "80%",
    },
  },
  adminCard: {
    height: "30vh",
  },
  tilesCard: {
    height: "100%",
    borderRadius: "4px",
    position: StyleVariables.relative,
    zIndex: "1",
    "&:after": {
      position: StyleVariables.absolute,
      height: StyleVariables.fullHeight,
      width: StyleVariables.fullWidth,
      top: StyleVariables.spacingZero,
      bottom: StyleVariables.spacingZero,
      left: StyleVariables.spacingZero,
      right: StyleVariables.spacingZero,
      zIndex: "-1",
    },
  },
  patientCard: {
    height: "30vh",
  },
  modalDiv: {
    display: "flex",
    flexDirection: "row",
    flexWrap: "nowrap",
    justifyContent: "center",
    alignItems: "center",
    alignContent: "stretch",
  },
  successText: {
    color: "gray",
    fontSize: "14px",
    whiteSpace: "normal",
    width: "92% !important",
  },
  buttonStyle: {
    backgroundColor: theme.palette.primary.main,
    margin: "0.5%",
    color: theme.palette.primary.contrastText,
    "&:hover": {
      backgroundColor: theme.palette.primary.main,
      boxShadow: `0 14px 26px -12px rgb(153 153 153 / 42%), 0 4px 23px 0px rgb(0 0 0 / 12%), 0 8px 10px -5px rgb(153 153 153 / 20%)`,
    },
    textTransform: "capitalize",
    lineHeight: "0.9",
    padding: "9px 25px",
    height: "32px",
    fontSize: "14px",
    borderRadius: "3px",
  },
}));

export default useStyles;
